<div class="wrapper">
  <router-outlet></router-outlet>
  <ngx-scrolltop backgroundColor="#6950A1" symbolColor="#FFFFFF"></ngx-scrolltop>
</div>
